<template lang="html">
    <div class="tab-personCenter">
        <MyTitle theTitle="个人中心"/>
        <div class="fd-banner">
           <!-- <h3></h3>-->
            <div class="fd-title">
                <div class="fd-title-inner">
                    <div class="fd-head-pthoto">
                        <img v-show="this.sex == 1" src="../../assets/image/boy.png" alt="">
                        <img v-show="this.sex == 2" src="../../assets/image/girl.png" alt="">
                    </div>
                    <div class="title-cont">
                        <h3>{{formData.cLoginName}}</h3>
                        <div>
                            <img src="../../assets/image/sfz.png" alt="">
                            <h6>{{formData.cPhoneno}}</h6>
                            <h6 class="fd-approve">{{cSfrz}}</h6>
                        </div>
                        <van-icon class="van-right-icon" name="arrow" @click="seeUserDetails"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="apply-content">
            <div class="apply-preservation" v-if="this.logStatus != 1">
                <van-cell-group>
                    <!-- <div class="item-field">
                        <img src="../../assets/image/icon-xgmm.png" alt="">
                        <van-field
                                label="修改密码"
                                class="left-field"
                                left-icon="icon-shouji"
                                right-icon="arrow"
                                @click="editPassword(formData.cUserid)"
                        ></van-field>
                    </div> -->
                    <div class="fd-interval-block"></div>
                    <div class="item-field">
                        <img class="close-icon" src="../../assets/image/close.png" alt="">
                        <van-field
                                label="退出"
                                class="left-field"
                                left-icon="icon-shouji"
                                @click="logout"
                        ></van-field>
                    </div>
                </van-cell-group>
            </div>
            <div class="apply-preservation" v-if="this.logStatus == 1">
                <div class="item-field">
                    <img src="../../assets/image/guide.png" alt="">
                    <van-field
                            label="用户指引"
                            class="left-field"
                            left-icon="icon-shouji"
                            @click="checkGuide"
                    ></van-field>
                </div>
            </div>
            <van-dialog
                v-model="isCheckGuide"
                title="提示"
                message="您可用电脑访问以下网址：https://baoquan.court.gov.cn/注册并实名认证，办理相关业务或查看业务进展"
                >
            </van-dialog>

<!--            <van-button class="exit-btn" size="large" @click="logout" type="default">退出</van-button>-->
            <iframe
                    id="logout-iframe"
                    :src="logoutUrl"
            ></iframe>
        </div>
    </div>
</template>

<script>
    import {setToken} from '@/utils/auth';
    import MyTitle from '../../components/common/myTitle';
    export default {
        data() {
            return {
                userType: 1,
                sex:'',
                logStatus:'',
                nUsersource:'',
                isCheckGuide:false,
                formData: {
                    cUserid: '',
                    cLoginName: '',// 共有的 用户名
                    cPhoneno: '',
                    cCertification: '',
                    zjhm:'',
                },
                cSfrz: '',
                logoutUrl: ''
            }
        },
        components: {
            MyTitle,
        },
        methods: {
            //微法院登录的用户指引
            checkGuide(){
                this.isCheckGuide = true
            },
            async getBasicInfo(){
                let url = this.nUsersource == 2 ? '/wfyUserInfo' : '/info'
                //TODO
                // await  this.$axios.get('account/api/wfyUserInfo')
                 await this.$axios.get('account/api/info')
                        .then(res => {
                            let data = res.data;
                            this.formData = data;
                            if (this.formData.cCertification == "true") {
                                this.cSfrz = "已认证";
                            } else {
                                this.cSfrz = "未认证";
                            }
                            this.formData.zjhm = res.data.cZjh

                        }).catch(function (error) {
                        console.log(error)
                    });
                await this.$axios.post('account/api/account/brithdate?identity='+this.formData.zjhm)
                        .then(res => {
                            this.sex = res.data.cSex
                        }).catch(function (error) {
                        console.log(error)
                    });
            },
            editPassword(id) {
                sessionStorage.setItem("editUserId", JSON.stringify(id));
                this.$router.push({
                    path: '/editUserPassword',
                })
            },
            seeUserDetails() {
                this.$router.push({
                    path: '/seeUserDetails',
                })
            },
            logout() {
                // 清空缓存
                localStorage.clear();
                // 临时配合测试
                this.$router.push("/login");
                // 调用内部后台登出接口
                // this.$axios.post("/account/api/account/logout")
                //     .then(() => {
                //         console.log("合适的话施工规范化的规范化的=====",process.env.VUE_APP_ALI_BASE_URL_PRO)
                //         this.logoutUrl = process.env.VUE_APP_ALI_BASE_URL_PRO + "/oauth/logout";
                //     });
            },
            addMessageListener: function () {
                window.addEventListener('message', (e) => {
                    let res = {
                        message: ''
                    };
                    try {
                        res = JSON.parse(e.data)
                    } catch (e) {
                        console.log(e);
                    }
                    //消息类型
                    if (res.message == '登出成功') {
                        // 清除失效token
                        setToken(null);
                        // 回到阿里登录页
                        this.$router.push("/ali_login");
                        this.$notify({
                            type: "success",
                            message: '登出成功'
                        });
                    }
                })
            }
        },
        created() {
             this.logStatus = window.sessionStorage.getItem("logSource")
            if(this.logStatus != 1){
                this.nUsersource = 2
            }
            this.addMessageListener();
        },
        mounted() {
            this.getBasicInfo();
        }
    }
</script>

<style lang="less" scoped>
    @import '../../font/iconfont.css';

    .tab-personCenter {
        overflow-y: scroll;
        width: 100%;
        height: 100%;
        background: #f3f3f3;

        .item-field {
            display: flex;
            position: relative;

            > img {
                height: 22px;
                position: absolute;
                z-index: 2;
                top: 12px;
                left: 12px;
            }

            .close-icon{
                width: 20px;
                margin-top: 2px;
            }

            .left-field {
                margin-left: 20px;
            }
        }

        .fd-head-pthoto{
            width: 80px;
            height: 80px;
            /*background:skyblue;*/
            border-radius: 50%;
            flex-shrink: 0;
            margin-top: 10px;
            margin-left: 10px;
            margin-right: 10px;
        }

        .fd-banner {
            width: 100%;
            padding-bottom: 13px;
            /*height: 51%;*/
            /*background: url('../../assets/image/icon-head.png') no-repeat center center;*/
            /*position: absolute;*/

            > h3 {
                font-size: 18px;
                color: #fff;
                text-align: center;
                padding-top: 30px/2;
            }

            .fd-title {
                .fd-title-inner {
                    display: flex;
                    background: #fff;
                    .title-logo {
                        width: 90px/2;
                        height: 104px/2;
                        margin-top: 6px;
                    }
                }

                .title-cont {
                    width: 100%;
                    height: 100px;
                    position: relative;
                    color:#333;
                    > h3 {
                        display: flex;
                        font-size:20px;
                        margin-top: 20px;
                    }

                    > div {
                        margin-top: 8px;
                        /*color: #fff;*/
                        display: flex;
                        height: 30px;
                        align-items: center;
                        position: relative;
                        > h6 {
                            flex-shrink: 0;
                            font-size: 18px;
                        }

                        > img {
                            width: 20px;
                            height: 15px;
                            margin-right: 8px;
                        }

                        > span {
                            margin-left: 13px;
                            font-size: 18px;
                        }

                    }
                    .fd-approve{
                        margin-left: 20px;
                    }

                    > h2 {
                        font-size: 30px;
                        color: #fff;
                        text-align: left;
                        letter-spacing: 5px;
                    }

                    > span {
                        font-size: 12px;
                        color: #fff;
                        display: block;
                        text-align: left;
                        margin-top: 4px;
                        white-space: nowrap;
                        border-radius: 15px;
                    }
                }
            }
        }

        .apply-content {
           /* <!--padding-top: 440px/1.5;-->*/
            width: 100%;
           /* margin-left: 5%;*/
        }
    }

    .van-right-icon{
        position: absolute;
        right: 4%;
        top: 38%;
        font-size: 24px;
        color:#959595;
    }

    .exit-btn {
        background: #fff;
        color: red;
        -webkit-border-radius: 6px;
        -moz-border-radius: 6px;
        border-radius: 6px;
        margin-top: 11px;
    }

    .fd-apply-button {
        color: #ff3b59;
        background: linear-gradient(to right, white, white);
        width: 100%;
        height: 100%;
        line-height: 30px;
        font-size: 14px;
        border-radius: 15px;
        display: inline-block;
    }

    .fd-interval-block{
        width: 100%;
        height: 13px;
        background: #f3f3f3;
    }

    #logout-iframe {
        display: none;
    }
    /deep/.van-button__text{
        color: #fff !important;
    }
</style>
